import castToType from './castToType.js'
import isEmpty from './isEmpty.js'
//-----------------------
// track profile changes
//-----------------------
export default function trackProfileChanges({
  field,
  character,
  original_profile,
  changed_profile,
}) {
  //
  console.log('-----------------------')
  console.log('IN trackProfileChanges')

  console.log('field = ' + field)
  // console.log('original_profile = ', original_profile)
  // console.log('changed_profile = ', changed_profile)
  // console.log('-----------------------')
  //---------------------
  // check args received
  //---------------------
  if (
    isEmpty(field) ||
    isEmpty(character) ||
    isEmpty(original_profile) ||
    changed_profile === undefined
  ) {
    return []
  }
  //---------------------------------------
  // ensure payload in object (first pass)
  //---------------------------------------
  if (!changed_profile.payload) {
    changed_profile.payload = {}
  }
  //--------------------------------
  // field already in change object
  //--------------------------------
  if (field in changed_profile.payload) {
    console.log('1. PROFILE FIELD ALREADY IN CHANGED OBJECT: ' + field)

    // value not original
    if (original_profile[field] !== character[field]) {
      console.log('2. PROFILE FIELD VAL CHANGED: ' + field, ' to ' + character[field])
      // update field entry
      changed_profile.payload[field] = castToType(original_profile[field], character[field])
      console.log('changed_profile entry for ' + field)

      // value is original - remove from object
    } else {
      console.log('3. PROFILE FIELD NOT CHANGED: ' + field)
      delete changed_profile.payload[field]
      console.log('changed_profile field removed')
    }
    //----------------------------
    // field NOT in change object
    //----------------------------
  } else {
    console.log('4. PROFILE FIELD NOT IN CHANGED OBJECT: ' + field)
    /*
    changed profile structure:
    {
      name: character.name,
      slug: character.slug,
      payload: {
        [field]: [value], (repeated per profile field changed)
      },
    */
    //------------------------------------------------------
    // store change entry (type mapped from original value)
    //------------------------------------------------------
    changed_profile.payload[field] = castToType(original_profile[field], character[field])
    console.log('changed_profile entry added')
  }
  return changed_profile
}
